export default __webpack_public_path__ + "static/media/Group3398-tata-neu@2x.7313bc80.png";